import React,{useState} from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import TrustStrip from '../components/sections/TrustStrip';
import ActualProof from '../components/sections/ActualProof';
import Transformation from '../components/sections/Transformation';
import VideoShowcase from '../components/sections/VideoShowcase';
import ServiceOutputs from '../components/sections/ServiceOutputs';
import Pricing from '../components/sections/Pricing';
import PainCards from '../components/sections/PainCards';
import Process from '../components/sections/Process';
import Reviews from '../components/sections/Reviews';
import FAQ from '../components/sections/FAQ';
import Contact from '../components/sections/Contact';
import FinalCTA from '../components/sections/FinalCTA';

const LandingPage=()=> {
  const [selectedPackage,setSelectedPackage]=useState('');
  const handlePackageSelection=(packageName)=> {
    setSelectedPackage(packageName);
  };
  return (
    <main className="min-h-screen luxury-page-bg">
      <Navbar />
      <Hero />
      <TrustStrip />
      <ActualProof />
      <Transformation />
      <VideoShowcase />
      <ServiceOutputs />
      <Pricing onSelectPackage={handlePackageSelection} />
      <PainCards />
      <Process />
      <Reviews />
      <FAQ />
      <Contact selectedPackage={selectedPackage} />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default LandingPage;